export const changeColumnsDealing = (
  unit,
  attendance,
  client,
  ratedIn,
  response,
  profile,
  note,
  os,
  attendant,
  status
) => ({
  type: "CHANGE_COLUMNS_DEALING",
  unit,
  attendance,
  client,
  ratedIn,
  response,
  profile,
  note,
  os,
  attendant,
  status,
});
